import { addParamsToUrl } from "@outschool/routes";

export enum ModalContext {
  UnenrolledClass,
  EnrolledClass,
  GenericReferral,
  SharedEducatorWithFriend,
  SharedEducatorProfile,
  FavoritesList,
}

type SharedThing = "activity" | "leader" | "invite" | "favorites";
type SharedSource =
  | "link"
  | "web_share_api"
  | "facebook"
  | "messenger"
  | "email"
  | "kakao"
  | "line";
type UtmParam = `share_${SharedThing}_${SharedSource}`;

function getSharedThing(ctx: ModalContext): SharedThing {
  if (
    [ModalContext.EnrolledClass, ModalContext.UnenrolledClass].includes(ctx)
  ) {
    return "activity";
  }

  if (
    [
      ModalContext.SharedEducatorProfile,
      ModalContext.SharedEducatorWithFriend,
    ].includes(ctx)
  ) {
    return "leader";
  }

  if (ctx === ModalContext.FavoritesList) {
    return "favorites";
  }

  if (ctx === ModalContext.GenericReferral) {
    return "invite";
  }

  return "invite";
}

export function getUtmCampaign(
  modalContext: ModalContext,
  sharedSource: SharedSource
): UtmParam {
  return `share_${getSharedThing(modalContext)}_${sharedSource}` as UtmParam;
}

export function addShareUtmCampaign(
  link: string,
  modalContext: ModalContext,
  sharedSource: SharedSource
): string {
  return addParamsToUrl(link, {
    utm_campaign: getUtmCampaign(modalContext, sharedSource),
  });
}
